import { useFragment } from '@apollo/client/react';
import { Menu } from '@pocketlaw/tetris';
import { useField } from 'formik';
import { AddMetadataLabelFragmentFragmentDoc } from './AddMetadataLabelFragment.gql';
import { RemoveSelection } from './RemoveSelection';
import { SubmitSelection } from './SubmitSelection';
export function AddMetadataMultiLineTextSelection(props) {
    const { from } = props;
    const [field] = useField('value');
    const { data, complete } = useFragment({
        from,
        fragment: AddMetadataLabelFragmentFragmentDoc,
    });
    if (!complete) {
        return null;
    }
    return (<Menu.ItemNested target={data.label}>
      <Menu.TextArea label={data.label} {...field}/>
      <Menu.Footer sticky withoutPadding>
        <SubmitSelection />
        <RemoveSelection />
      </Menu.Footer>
    </Menu.ItemNested>);
}
